import { Event } from '@/event-bus/event';

export class MassEditFocusContentEvent extends Event<void> {}
